<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'ApplicationAliasList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Application Alias
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'ApplicationAliasList' }">Application Alias</router-link>
              </li>
              <li class="breadcrumb-item active">{{ is_edit ? 'Edit' : 'Create' }}</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="applicationAliasForm">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">Device Type</label>
                    <input
                      type="text"
                      id="device_type"
                      name="device_type"
                      v-model="value.device_type"
                      v-validate.lazy="{required: true, max: 255}"
                      class="form-control"
                      placeholder="Enter Device Type"
                      v-bind:class="{ 'has-error': errors.has('device_type') }"
                    />
                    <div class="help text-danger" v-show="errors.has('device_type')">
                      {{ errors.first("device_type") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Alias</label>
                    <input
                      type="text"
                      id="alias"
                      name="alias"
                      v-model="value.alias"
                      v-validate.lazy="{required: true, max: 255}"
                      class="form-control"
                      placeholder="Enter Alias"
                      v-bind:class="{ 'has-error': errors.has('alias') }"
                    />
                    <div class="help text-danger" v-show="errors.has('alias')">
                      {{ errors.first("alias") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="switch-row justify-content-between">
                      <label class="control-label">
                        <i class="fas fa-phone-alt mr-2" aria-hidden="true"></i>
                        VoIP Enable
                      </label>
                      <el-switch
                        v-model="value.voip_enable"
                        active-color="#009E9D"
                        inactive-color="#E5E5E5"
                        :active-value="true"
                        :inactive-value="false"
                      >
                      </el-switch>
                    </div>
                    <div class="help text-danger" v-show="errors.has('voip_enable')">
                      {{ errors.first("voip_enable") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
              <router-link 
                :to="{ name: 'ApplicationAliasList' }" 
                class="btn btn-outline ml-2"
              >
                Cancel
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";

export default {
  name: "ApplicationAliasForm",
  metaInfo: {
    title: "Application Alias | Dotlines",
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      device_type: '',
      alias: '',
      voip_enable: false  // Boolean value for el-switch
    },
    pre: {
  
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/application-alias";
          let method = "POST";
          
          if (_this.is_edit) {
            api_url = "/application-alias/" + _this.$route.params.id;
            method = "PUT";
          }

          // Convert boolean to string/number for API
          let submitData = { ..._this.value };
          submitData.voip_enable = _this.value.voip_enable ? 1 : 0;

          axios({
            method: method,
            url: api_url,
            data: submitData,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message || 'Operation completed successfully');
              _this.$router.push({ name: "ApplicationAliasList" });
            })
            .catch((errors) => {
              if (errors.response && errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.message || 'Validation error occurred');
                if (errors.response.data.errors) {
                  _this.$setErrorsFromResponse(errors.response.data.errors);
                }
              } else if (errors.response && errors.response.data) {
                _this.$toaster.error(errors.response.data.message || 'An error occurred');
                if (errors.response.data.errors) {
                  _this.$setErrorsFromResponse(errors.response.data);
                }
              } else {
                _this.$toaster.error('An unexpected error occurred');
              }
              console.error('Submission error:', errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/application-alias/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }

      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = { ...response.data };
            
            // Convert API response (0/1) to boolean for el-switch
            // API returns: {"id":6,"device_type":"sathy","alias":"safe sdfg","voip_enable":1}
            if (this.value.voip_enable !== null && this.value.voip_enable !== undefined) {
              this.value.voip_enable = Boolean(Number(this.value.voip_enable));
            } else {
              this.value.voip_enable = false; // Default to disabled
            }
          })
          .catch((errors) => {
            if (errors.response && errors.response.status === 404) {
              this.$toaster.error('Application alias not found');
            } else if (errors.response && errors.response.data) {
              this.$toaster.error(errors.response.data.message || 'Failed to load data');
            } else {
              this.$toaster.error('Failed to load application alias data');
            }
            this.$router.push({ name: "ApplicationAliasList" });
          });
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
.has-error {
  border-color: #dc3545 !important;
}

.help.text-danger {
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.btn-outline {
  background-color: transparent;
  border-color: #6c757d;
  color: #6c757d;
}

.btn-outline:hover {
  background-color: #6c757d;
  color: white;
}

.switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.switch-row .control-label {
  margin-bottom: 0;
  font-weight: 500;
}
</style>